<template>
    <section>
        <!-- LEGAL STATUS -->
        <el-form-item
            prop="legalFrance.companyType"
            :label="$t.__('thirds.thirdscomponents.FormFieldsLegalAndBilling.company_type')"
            :error="getErrorKey(`legal_france.rcs_immatriculation`)"
        >
            <el-input
                :data-bot="getDatabot('company-type', currentStore, 'legal-billing')"
                autocomplete="off"
                v-model="legal.companyType"
            ></el-input>
        </el-form-item>

        <!-- SIRET -->
        <el-form-item
            prop="legalFrance.siret"
            :label="$t.__('common.labels.siret')"
            :error="getErrorKey(`legal_france.siret`)"
        >
            <el-input
                :data-bot="getDatabot('siret', currentStore, 'legal-billing')"
                autocomplete="off"
                v-model="legal.siret"
            ></el-input>
        </el-form-item>

        <!-- SIREN -->
        <el-form-item
            prop="legalFrance.siren"
            :label="$t.__('common.labels.siren')"
            :error="getErrorKey(`legal_france.siren`)"
        >
            <el-input
                :data-bot="getDatabot('siren', currentStore, 'legal-billing')"
                autocomplete="off"
                v-model="legal.siren"
            ></el-input>
        </el-form-item>

        <!-- APE -->
        <el-form-item
            prop="legalFrance.apeNafCode"
            :label="$t.__('thirds.thirdscomponents.FormFieldsLegalAndBilling.NAF_code')"
            :error="getErrorKey(`legal_france.ape_naf_code`)"
        >
            <el-input
                :data-bot="getDatabot('ape-naf', currentStore, 'legal-billing')"
                autocomplete="off"
                v-model="legal.apeNafCode"
            ></el-input>
        </el-form-item>

        <!-- CAPITAL -->
        <el-form-item
            prop="legalFrance.capital"
            :label="$t.__('thirds.thirdscomponents.FormFieldsLegalAndBilling.initial_capital')"
            :error="getErrorKey(`capital`)"
        >
            <el-input
                :data-bot="getDatabot('capital', currentStore, 'legal-billing')"
                autocomplete="off"
                v-model="capital"
            ></el-input>
        </el-form-item>

        <!-- RCS -->
        <el-form-item
            prop="legalFrance.rcsImmatriculation"
            :label="$t.__('thirds.thirdscomponents.FormFieldsLegalAndBilling.RCS')"
            :error="getErrorKey(`legal_france.rcs_immatriculation`)"
        >
            <el-input
                :data-bot="getDatabot('rcs', currentStore, 'legal-billing')"
                autocomplete="off"
                v-model="legal.rcsImmatriculation"
            ></el-input>
        </el-form-item>

        <!-- VAT -->
        <el-form-item
            prop="legalFrance.vat"
            :label="$t.__('thirds.thirdscomponents.FormFieldsLegalAndBilling.VAT_number')"
            :error="getErrorKey(`legal_france.vat`)"
        >
            <el-input
                :data-bot="getDatabot('vat', currentStore, 'legal-billing')"
                autocomplete="off"
                v-model="legal.vat"
            ></el-input>
        </el-form-item>
    </section>
</template>

<script>
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';
export default {
    props: {
        currentStore: {
            type: String,
            required: true,
        },
        error: {
            type: [Object, Array],
            required: false,
        },
    },
    mixins: [DataBotsFormsMixins],
    computed: {
        capital: {
            get() {
                return this.$store.getters[`${this.currentStore}/getCapital`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setCapital`, value);
            },
        },
        legal: {
            get() {
                return this.$store.getters[`${this.currentStore}/getLegalFrance`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setLegalFrance`, value);
            },
        },
    },
    methods: {
        /**
         * API error returned is one error per error
         */
        getErrorKey(errorKey) {
            let errorMsg = '';
            let currentError = this.error ? Object.values(this.error) : '';
            if (currentError && errorKey === Object.keys(this.error)[0]) {
                errorMsg = currentError[0];
            }
            return errorMsg;
        },
    },
};
</script>
